export default __webpack_public_path__ + "static/blob-21-063b771b1d516fae44a5d59db651aa0f.svg";